import { defineStore } from "pinia";
import { ref } from "vue";
import Tenant from "../../../types/auth/Tenant";

export const organizationsStore = defineStore("organizationsStore", () => {
  const isHidden = ref<boolean>(true);
  const tenants = ref<Array<Tenant>>();
  const currentTenant = ref<Tenant>();

  const getIsHidden = () => {
    return isHidden.value;
  };

  const toggleIsHidden = () => {
    isHidden.value = !isHidden.value;
  };

  const getTenants = () => {
    return tenants.value;
  };

  const setTenants = (newTenants: Array<Tenant>) => {
    tenants.value = newTenants;
  };

  const getCurrentTenant = () => {
    return currentTenant.value;
  };

  const setCurrentTenant = (newTenant: Tenant) => {
    currentTenant.value = newTenant;
  };

  return {
    getIsHidden,
    toggleIsHidden,
    getTenants,
    setTenants,
    getCurrentTenant,
    setCurrentTenant,
  };
});
